export const ImageMimeType = `image/.*`;
export const VideoMimeType = `video/.*`;
